import { DEVICE, MARKET_AUDIENCE } from "../../utils/constants";
import { HeaderNarrow } from "./HeaderNarrow";
import { HeaderWide } from "./HeaderWide";
import { Media } from "gatsby-plugin-fresnel";
import { MofoPromises } from "../mofo-promises/MofoPromises";
import { useIsWinePage } from "../../hooks/use-is-wine-page";
import { graphql, useStaticQuery } from "gatsby";
import { storefrontNavigationItemProps } from "../../types/vino-data-types";
import { hasSpiritsInPath } from "../../utils/is-page";

interface NavigationLink {
  name: string;
  nameMobile: string;
  link: {
    url: string;
  };
  device: Array<"desktop" | "mobile">;
}

const WHISKYMOFO_HEADER_ENABLED =
  process.env.GATSBY_ENABLE_WHISKYMOFO_HEADER === "true";

export const Header = ({ pathname }: { pathname?: string }): JSX.Element => {
  const isWinePage = useIsWinePage();
  const isSpiritPage = hasSpiritsInPath(pathname);

  const { vinodata } = useStaticQuery(graphql`
    query {
      vinodata {
        whiskymofoMenu: headerNavigation(name: "Whiskymofo") {
          name
          list {
            name
            nameMobile
            link {
              url
            }
            device
          }
        }
        defaultMenu: headerNavigation {
          name
          list {
            name
            nameMobile
            link {
              url
            }
            device
          }
        }
      }
    }
  `);

  const headerData =
    WHISKYMOFO_HEADER_ENABLED && isSpiritPage
      ? vinodata.whiskymofoMenu
      : vinodata.defaultMenu;

  const menuItems: storefrontNavigationItemProps[] =
    headerData?.list?.map((item: NavigationLink) => ({
      link: item.link?.url,
      label: item.name,
      labelMobile: item.nameMobile,
      audience: MARKET_AUDIENCE.ALL,
      device: item.device,
    })) || [];

  return (
    <>
      <Media between={["sm", "md"]}>
        <HeaderNarrow
          menuItems={menuItems}
          isWhiskymofoEnabled={WHISKYMOFO_HEADER_ENABLED && isSpiritPage}
        />
      </Media>
      <Media between={["md", "lg"]}>
        <HeaderWide
          menuItems={menuItems?.map((item) => ({
            ...item,
            label: item.labelMobile || item.label,
          }))}
          isWhiskymofoEnabled={WHISKYMOFO_HEADER_ENABLED && isSpiritPage}
        />
      </Media>
      <Media greaterThanOrEqual="lg">
        <HeaderWide
          menuItems={menuItems}
          isWhiskymofoEnabled={WHISKYMOFO_HEADER_ENABLED && isSpiritPage}
        />
      </Media>
      {isWinePage && <MofoPromises />}
    </>
  );
};

Header.displayName = "Header";
